import Axios from "axios";
import { antdMessageError, antdMessageSuccess } from "../../helpers/Utils";
import { POST_COMMENTS_TO_ORDERS, CLEAR_ERRORS } from "./types";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

export const createComment = (variables) =>
  Axios.post("/api/v1/comments", variables);

export const postComments = (variables) => async (dispatch) => {
  const key = "postComments";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post("/api/v1/comments", variables);
    dispatch({
      type: POST_COMMENTS_TO_ORDERS,
      payload: data,
    });
    antdAsyncMessageSuccess({ key });
    return { success: true };
  } catch (err) {
    const error =
      err?.response?.data?.errors || err?.message || "Error occurred";
    antdAsyncMessageError({ key, text: error });
    return { success: false, error };
  }
};

export const postMassCommentsAndStatus = (variables) => (dispatch) => {
  return Axios.post("/api/v1/comments/set_mass_comments_status", variables)
    .then((res) => {
      dispatch({
        type: "UPDATE_BULK_COMMENT_STATUS",
        payload: { ...res.data, orders_ids: variables.orders_ids },
      });
      if (res.data.errors && res.data.errors.length > 0) {
        res.data.errors.forEach((error) => {
          antdMessageError(error);
        });
      } else {
        antdMessageSuccess();
      }
      return res.data;
    })
    .catch((err) => {
      antdMessageError(err.response?.data?.message || "Operation failed");
      return { success: false, errors: err.response?.data?.errors || [] };
    });
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
